import { createContext, useContext, useState, type ReactNode } from 'react';
import type { Crumb } from '../Header/headerCrumbs.js';

export type PageHeaderData = { title?: string; count?: ReactNode; breadcrumbs?: Crumb[]; actions?: ReactNode };

/* Two contexts: the STATE changes on every publish (the Header reads it); the SETTER is stable (PageContainer reads only that), so publishing never re-renders the page that published. */
const StateContext = createContext<PageHeaderData>({});
const SetterContext = createContext<(header: PageHeaderData) => void>(() => {});

export const PageHeaderProvider = ({ children }: { children: ReactNode }) => {
    const [header, setHeader] = useState<PageHeaderData>({});
    return (
        <SetterContext.Provider value={setHeader}>
            <StateContext.Provider value={header}>{children}</StateContext.Provider>
        </SetterContext.Provider>
    );
};
export const usePageHeaderState = () => useContext(StateContext);
export const useSetPageHeader = () => useContext(SetterContext);
